<template>
  <v-app dark>
    <v-app-bar app color="#08243c" dark clipped-left>
      <v-layout>
        <div class="d-flex align-center">
          <img
            alt="Caddy Workflow logo"
            src="./assets/logo.png"
            style="height: 40px;"
          />
        </div>
      </v-layout>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon
        v-if="loggedInUser != null"
        @click="drawer = true"
      ></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      right
      temporary
      v-if="loggedInUser != null"
    >
      <v-list dense nav>
        <v-list-item-group>
          <div v-for="item in navItems" :key="item.title">
            <v-list-item v-if="item.show == true" :to="item.link">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-divider></v-divider>
          <div>
            <v-list-item v-if="loggedInUser != null" @click="signOut">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  loggedInUser.name.split(' ')[0] +
                    ' ' +
                    loggedInUser.name.split(' ')[1][0] +
                    '.'
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
    <v-footer dark padless app permanent>
      <v-card class="flex" color="#08243c" flat tile>
        <v-card-text class="py-2 white--text text-left">
          <v-icon left small>mdi-copyright</v-icon>
          {{ new Date().getFullYear() }}
          Caddy Workflow LLC
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'

export default {
  name: 'App',

  data: () => ({
    signedIn: false,
    drawer: false,
    standardUserViews: ['Dashboard', 'Projects'],
    adminUserViews: ['Dashboard', 'Projects', 'Analytics', 'Team', 'Settings'],
    navItems: [
      {
        title: 'Dashboard',
        icon: 'mdi-view-dashboard',
        link: { name: 'dashboard' },
        show: false,
      },
      {
        title: 'Projects',
        icon: 'mdi-folder',
        link: { name: 'projects' },
        show: false,
      },
      {
        title: 'Analytics',
        icon: 'mdi-chart-bar',
        link: { name: 'analytics' },
        show: false,
      },
      {
        title: 'Team',
        icon: 'mdi-account-multiple',
        link: { name: 'team' },
        show: false,
      },
      {
        title: 'Settings',
        icon: 'mdi-cog',
        link: { name: 'settings' },
        show: false,
      },
    ],
  }),
  beforeMount() {
    let self = this
    self.loading = true
    AmplifyEventBus.$on('authState', info => {
      if (info === 'signedIn') {
        this.$store.dispatch('setUser')
        this.$router.push('dashboard')
      }
      if (info === 'signedOut') {
        this.$store.dispatch('clearUser')
        this.$router.push('login')
      }
    })

    Auth.currentAuthenticatedUser()
      .then(user => {
        this.$store.dispatch('setUser', user)
      })
      .catch(() => {
        this.$store.dispatch('clearUser')
      })
  },
  methods: {
    signOut: function() {
      Auth.signOut().then(() => {
        this.$store.dispatch('setUser', null)
        AmplifyEventBus.$emit('auth-state', 'signedOut')
        this.$router.push(`/${this.companyName}/login`)
      })
    },
  },
  computed: {
    loggedInUser() {
      return this.$store.getters.getLoggedInUser
    },
    fName() {
      return this.loggedInUser.split()[0]
    },
    companyId() {
      return this.$store.getters.getCompanyId
    },
    companyName() {
      return this.$store.getters.getCompanyName
    },
    mini() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },
  watch: {
    loggedInUser(val) {
      if (val != null) {
        let navItemsToShow = []
        if (val.type == 'Admin') {
          navItemsToShow = this.adminUserViews
        } else if (val.type == 'Standard') {
          navItemsToShow = this.standardUserViews
        }
        for (var nav of this.navItems) {
          nav.show = false
          for (var title of navItemsToShow) {
            if (nav.title == title) {
              nav.show = true
            }
          }
        }
      }
    },
  },
}
</script>

<style>
::-webkit-scrollbar {
  display: block;
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #08243c;
  border-right: none;
  border-left: none;
}

::-webkit-scrollbar-track-piece:end {
  background: transparent;
}

::-webkit-scrollbar-track-piece:start {
  background: transparent;
}
</style>
